<template>
  <element>
    <hr class="separator my-3 py-0" />
    <v-container class="neat-container">
      <v-row no-gutters>
        <v-col class="text-left">
          <h5 class="font-weight-bold">{{ name }}</h5>
          <h5>{{ $t('collectionListPage.details.inventory') }} {{ inventory }}</h5>
          <h5>{{ $t('collectionListPage.details.shelf') }} {{ shelf }}</h5>
          <h5>{{ $t('collectionListPage.details.room') }} {{ room }}</h5>
          <h5>{{ $t('collectionListPage.details.quantity') }} {{ quantity }}</h5>
          <v-checkbox
            class="my-0"
            v-model="is_found"
            :label="$t('collectionListPage.details.found')"
            color="#033e8c"
            hide-details
          >
          </v-checkbox>
        </v-col>
        <v-col>
          <img v-bind:src="img_url" width="172px" height="172px" alt="Collection Picture"/>
        </v-col>
      </v-row>
    </v-container>
  </element>
</template>

<script>
export default {
  name: "CollectionCard",
  props: {
    name: String,
    inventory: Number,
    shelf: Number,
    room: String,
    quantity: Number,
    found: Boolean,
    img_url: String,
  },
  data () {
    return {
      is_found: this.found
    }
  },
}
</script>

<style scoped>
h5 {
  font-size: 1.125rem;
}
</style>